import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CreateAccountOrganizationDto } from '@smmof/dto';
import { AccountOrganization } from '@smmof/entity';

export const AccountOrganizationActions = createActionGroup({
  source: 'AccountOrganization',
  events: {
    'Load Organizations': emptyProps(),
    'Load Organizations Success': props<{ organizations: AccountOrganization[] }>(),
    'Load Organizations Failure': props<{ error: any }>(),

    'Create Organization': props<{ organization: CreateAccountOrganizationDto }>(),
    'Create Organization Success': props<{ organization: AccountOrganization }>(),
    'Create Organization Failure': props<{ error: any }>(),

    // Новый экшен для сброса ошибки
    'Clear Organization Error': emptyProps(),
  },
});